import { uuid } from './utils'; // @note delete categories id
// import image from './assets/img/aubade.png';
const randomScale = (min, max) => {
  return min + Math.floor((max - min + 1) * Math.random());
};

export const categories = [
  {
    id: uuid(),
    title: 'Двухцветные',
    cards: [
      {
        id: uuid(),
        title: 'Атомик',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-80',
        image: '/img/atomic.png',
      },
      {
        id: uuid(),
        title: 'Аубаде',
        small: randomScale(0, 2),
        topSize: '6,6',
        bottomSize: '40-80',
        image: '/img/aubade.png',
      },
      {
        id: uuid(),
        title: 'Кабаре',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '50-80',
        image: '/img/cabaret.png',
      },
      {
        id: uuid(),
        title: 'Кэрроусел',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '40-70',
        image: '/img/carrousel.png',
      },
      {
        id: uuid(),
        title: 'Сезанн',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-80',
        image: '/img/cezanne.png',
      },
      {
        id: uuid(),
        title: 'Черри Бренди',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '40-70',
        image: '/img/cherry-brandy.png',
      },
      {
        id: uuid(),
        title: 'Эсперанс',
        small: randomScale(0, 2),
        topSize: '6,8',
        bottomSize: '50-80',
        image: '/img/esperance.png',
      },
      {
        id: uuid(),
        title: 'Фруттето',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-80',
        image: '/img/frutteto.png',
      },
      {
        id: uuid(),
        title: 'Хай и Мэджик',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '40-90',
        image: '/img/high-and-magic.png',
      },
      {
        id: uuid(),
        title: 'Хай и Йеллоу Флейм',
        small: randomScale(0, 2),
        topSize: '5,5',
        bottomSize: '40-60',
        image: '/img/high-and-yellow-flame.png',
      },
      {
        id: uuid(),
        title: 'Кахала',
        small: randomScale(0, 2),
        topSize: '6',
        bottomSize: '50-90',
        image: '/img/kahala.png',
      },
      {
        id: uuid(),
        title: 'Палома',
        small: randomScale(0, 2),
        topSize: '7,2',
        bottomSize: '50-80',
        image: '/img/paloma.png',
      },
      {
        id: uuid(),
        title: 'Свитнесс',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '50-100',
        image: '/img/sweetness.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Белые',
    cards: [
      {
        id: uuid(),
        title: 'Акито',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '50-80',
        image: '/img/akito.png',
      },
      {
        id: uuid(),
        title: 'Фёрст Леди',
        small: randomScale(0, 2),
        topSize: '6,8',
        bottomSize: '50-80',
        image: '/img/first-lady.png',
      },
      {
        id: uuid(),
        title: 'Мондиаль',
        small: randomScale(0, 2),
        topSize: '6,8',
        bottomSize: '50-120',
        image: '/img/mondial.png',
      },
      {
        id: uuid(),
        title: 'Плайя Бланка',
        small: randomScale(0, 2),
        topSize: '6',
        bottomSize: '40-70',
        image: '/img/playa-blanca.png',
      },
      {
        id: uuid(),
        title: 'Полар Стар',
        small: randomScale(0, 2),
        topSize: '6,6',
        bottomSize: '50-90',
        image: '/img/polar-star.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Красные',
    cards: [
      {
        id: uuid(),
        title: 'Эксплорер',
        small: randomScale(0, 2),
        topSize: '7,2',
        bottomSize: '50-130',
        image: '/img/explorer.png',
      },
      {
        id: uuid(),
        title: 'Файнали',
        small: randomScale(0, 2),
        topSize: '6',
        bottomSize: '50-80',
        image: '/img/finally.png',
      },
      {
        id: uuid(),
        title: 'Фридом',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-150',
        image: '/img/freedom.png',
      },
      {
        id: uuid(),
        title: 'Роял Эксплорер',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '50-80',
        image: '/img/royal-explorer.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Ярко-розовые',
    cards: [
      {
        id: uuid(),
        title: 'Альтамира',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-100',
        image: '/img/altamira.png',
      },
      {
        id: uuid(),
        title: 'Блашинг Акито',
        small: randomScale(0, 2),
        topSize: '6',
        bottomSize: '40-70',
        image: '/img/blushing-akito.png',
      },
      {
        id: uuid(),
        title: 'Готча',
        small: randomScale(0, 2),
        topSize: '7',
        bottomSize: '50-90',
        image: '/img/gotcha.png',
      },
      {
        id: uuid(),
        title: 'Хот Эксплорер',
        small: randomScale(0, 2),
        topSize: '7,5',
        bottomSize: '50-90',
        image: '/img/hot-explorer.png',
      },
      {
        id: uuid(),
        title: 'Лола',
        small: randomScale(0, 2),
        topSize: '7,2',
        bottomSize: '50-120',
        image: '/img/lola.png',
      },
      {
        id: uuid(),
        title: 'Пинк Флойд',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-110',
        image: '/img/pink-floyd.png',
      },
      {
        id: uuid(),
        title: 'Роузберри',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '50-90',
        image: '/img/roseberry.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Розовые',
    cards: [
      {
        id: uuid(),
        title: 'Чарминг Юник',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '40-90',
        image: '/img/charming-unique.png',
      },
      {
        id: uuid(),
        title: 'Ингейджмент',
        small: randomScale(0, 2),
        topSize: '6,8',
        bottomSize: '50-90',
        image: '/img/engagement.png',
      },
      {
        id: uuid(),
        title: 'Фейт',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '50-80',
        image: '/img/faith.png',
      },
      {
        id: uuid(),
        title: 'Эрмоза',
        small: randomScale(0, 2),
        topSize: '7,2',
        bottomSize: '50-100',
        image: '/img/hermosa.png',
      },
      {
        id: uuid(),
        title: 'Джессика',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-80',
        image: '/img/jessika.png',
      },
      {
        id: uuid(),
        title: 'Лоррейн',
        small: randomScale(0, 2),
        topSize: '7,5',
        bottomSize: '50-100',
        image: '/img/lorraine.png',
      },
      {
        id: uuid(),
        title: 'Лучиано',
        small: randomScale(0, 2),
        topSize: '7',
        bottomSize: '60-100',
        image: '/img/luciano.png',
      },
      {
        id: uuid(),
        title: 'Мать Жемчужины',
        small: randomScale(0, 2),
        topSize: '6,8-7',
        bottomSize: '50-60',
        image: '/img/mother-of-pearl.png',
      },
      {
        id: uuid(),
        title: 'Наутика',
        small: randomScale(0, 2),
        topSize: '7',
        bottomSize: '50-100',
        image: '/img/nautica.png',
      },
      {
        id: uuid(),
        title: 'Нена',
        small: randomScale(0, 2),
        topSize: '6',
        bottomSize: '40-80',
        image: '/img/nena.png',
      },
      {
        id: uuid(),
        title: 'Пинк Мондиаль',
        small: randomScale(0, 2),
        topSize: '6,8',
        bottomSize: '50-90',
        image: '/img/pink-mondial.png',
      },
      {
        id: uuid(),
        title: 'Розита Вендела',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '50-70',
        image: '/img/rosita-vendela.png',
      },
      {
        id: uuid(),
        title: 'Свит Акито',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '40-70',
        image: '/img/sweet-akito.png',
      },
      {
        id: uuid(),
        title: 'Свит Энсимо',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '40-70',
        image: '/img/sweet-escimo.png',
      },
      {
        id: uuid(),
        title: 'Свит Юник',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '50-100',
        image: '/img/sweet-unique.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Лавандовые',
    cards: [
      {
        id: uuid(),
        title: 'Кулл Уотер',
        small: randomScale(0, 2),
        topSize: '5,5',
        bottomSize: '40-60',
        image: '/img/cool-water.png',
      },
      {
        id: uuid(),
        title: 'Дип Пёрпл',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '50-100',
        image: '/img/deep-purple.png',
      },
      {
        id: uuid(),
        title: 'Муди Блюз',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-90',
        image: '/img/moody-blues.png',
      },
      {
        id: uuid(),
        title: 'Оушн Сонг',
        small: randomScale(0, 2),
        topSize: '5',
        bottomSize: '40-60',
        image: '/img/ocean-song.png',
      },
      {
        id: uuid(),
        title: 'Пёрпл Хэйз',
        small: randomScale(0, 2),
        topSize: '5,3',
        bottomSize: '40-60',
        image: '/img/purple-haze.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Кремовые',
    cards: [
      {
        id: uuid(),
        title: 'Крим де ля крим',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '50-70',
        image: '/img/creme-de-la-creme.png',
      },
      {
        id: uuid(),
        title: 'Кристал',
        small: randomScale(0, 2),
        topSize: '7,2',
        bottomSize: '50-70',
        image: '/img/crystal.png',
      },
      {
        id: uuid(),
        title: 'Марвел',
        small: randomScale(0, 2),
        topSize: '7',
        bottomSize: '50-100',
        image: '/img/marvel.png',
      },
      {
        id: uuid(),
        title: 'Марципан',
        small: randomScale(0, 2),
        topSize: '7',
        bottomSize: '50-80',
        image: '/img/marzipan.png',
      },
      {
        id: uuid(),
        title: 'Помпеи',
        small: randomScale(0, 2),
        topSize: '7,2',
        bottomSize: '50-100',
        image: '/img/pompeii.png',
      },
      {
        id: uuid(),
        title: 'Квиксэнд',
        small: randomScale(0, 2),
        topSize: '5,6',
        bottomSize: '50-80',
        image: '/img/quicksand.png',
      },
      {
        id: uuid(),
        title: 'Талеа',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '40-60',
        image: '/img/talea.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Персиковые',
    cards: [
      {
        id: uuid(),
        title: 'Корал Риф',
        small: randomScale(0, 2),
        topSize: '6',
        bottomSize: '50-80',
        image: '/img/coral-reef.png',
      },
      {
        id: uuid(),
        title: 'Примавера',
        small: randomScale(0, 2),
        topSize: '6,9',
        bottomSize: '50-70',
        image: '/img/primavera.png',
      },
      {
        id: uuid(),
        title: 'Сальма',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '60-110',
        image: '/img/salma.png',
      },
      {
        id: uuid(),
        title: 'Шиммер',
        small: randomScale(0, 2),
        topSize: '6,5',
        bottomSize: '50-80',
        image: '/img/shimmer.png',
      },
    ],
  },
  {
    id: uuid(),
    title: 'Оранжевые',
    cards: [
      {
        id: uuid(),
        title: 'Энканто',
        small: randomScale(0, 2),
        topSize: '6,2',
        bottomSize: '40-60',
        image: '/img/encanto.png',
      },
      {
        id: uuid(),
        title: 'Фри Спирит',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '50-70',
        image: '/img/free-spirit.png',
      },
      {
        id: uuid(),
        title: 'Нина',
        small: randomScale(0, 2),
        topSize: '5,8',
        bottomSize: '50-100',
        image: '/img/nina.png',
      },
      {
        id: uuid(),
        title: 'Орэндж Краш',
        small: randomScale(0, 2),
        topSize: '5,6',
        bottomSize: '50-70',
        image: '/img/orange-crush.png',
      },
    ],
  },
];

export const categoryHeight = window.innerWidth >= 768 ? 553 : 436;

export const categoryCards = [
  {
    id: uuid(),
    small: randomScale(0, 2),
  },
  {
    id: uuid(),
    small: randomScale(0, 2),
  },
  {
    id: uuid(),
    small: randomScale(0, 2),
  },
  {
    id: uuid(),
    small: randomScale(0, 2),
  },
  {
    id: uuid(),
    small: randomScale(0, 2),
  },
  {
    id: uuid(),
    small: randomScale(0, 2),
  },
  {
    id: uuid(),
    small: randomScale(0, 2),
  },
];
